import { acquireAccessToken, tryGetAzureAuthInstance } from "@datamole/wds-azure-auth";

import { config } from "@/config";
import { ACCESS_TOKEN_STORAGE_KEY } from "@/features/auth/auth.constants";

export const loadAccessToken = (): string | null => {
    return localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);
};

export const storeAccessToken = (token: string): void => {
    localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, token);
};

export const clearAccessToken = (): void => {
    localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
};

const baseFetch = (input: string | Request | URL, init?: RequestInit): Promise<Response> => {
    const accessToken = loadAccessToken();

    const authHeaders: HeadersInit = accessToken
        ? {
              Authorization: `Bearer ${accessToken}`,
          }
        : {};

    const initWithAuth: RequestInit = {
        ...init,
        headers: {
            ...(init?.headers || {}),
            ...authHeaders,
        },
    };

    return fetch(input, initWithAuth);
};

export const fetchWithAuth = async (input: string | Request | URL, init?: RequestInit): Promise<Response> => {
    const response = await baseFetch(input, init);

    if (response.status === 401) {
        // Refresh the token on 401 Unauthorized and try again.
        const azureAdInstance = tryGetAzureAuthInstance();

        const accessToken = await acquireAccessToken(
            {
                scopes: [config.AZURE_AD_AUTH_SCOPE],
            },
            azureAdInstance,
        );

        if (accessToken) {
            storeAccessToken(accessToken);
        } else {
            clearAccessToken();
        }

        return baseFetch(input, init);
    }

    return response;
};

export const getAuthenticatedUserInfo = () => {
    const azureAdInstance = tryGetAzureAuthInstance();
    const account = azureAdInstance.getActiveAccount() ?? azureAdInstance.getAllAccounts()[0];

    return {
        email: account?.username ?? "",
        displayName: account?.name ?? "",
    };
};
